module.exports = __webpack_public_path__ + "static/media/serving-icon.87135989.svg";